import React from 'react';
import { CurrentPageWrapper } from './styled';

const CurrentPage = () => (
  <CurrentPageWrapper id="current-page" className="pt-3" />
);

export default CurrentPage;
